import connect from "@classdojo/web/utils/hoc/connect";
import NoiseDisplay from "./NoiseDisplay";
import {
  appMetadataNoise,
  selectGain,
  selectShowSensitivityInput,
  sendNoise,
  sendMicrophonePermissionError,
  NoiseState,
} from "src/pods/noise";
import { displayClose } from "src/pods/realtime";
import PresentationPage from "src/shared/components/PresentationPage";

type NoiseDisplayContainerProps = {
  displayClose?: VoidFunction;
  sendNoise: (payload: { gain: number }) => void;
  gain?: number;
  showSensitivityInput?: boolean;
  onPermissionError: (errorName: string | null) => void;
};

const mapStateToProps = (state: NoiseState) => {
  return {
    gain: selectGain(state),
    showSensitivityInput: selectShowSensitivityInput(state),
  };
};
const mapDispatchToProps = { sendNoise, onPermissionError: sendMicrophonePermissionError, displayClose };
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)((props: Partial<NoiseDisplayContainerProps>) => (
  <PresentationPage {...appMetadataNoise()} onRequestHide={props.displayClose}>
    <NoiseDisplay {...props} />
  </PresentationPage>
));
